// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8af57e2e","453":"30a5e491","455":"c234d163","977":"ad50dcb3"}[chunkId] + ".chunk.js";
};